"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MergedRules = void 0;
/**
 * `mergeDedupedPageStates` without the uniques: per rule, the first page state's fields (the
 * merge seeds from a clone of it), a unique count, and duplicate counts in first-seen key order.
 */
class MergedRules {
    #rules = new Map();
    get size() {
        return this.#rules.size;
    }
    add(pageState) {
        for (const ruleResult of pageState.result) {
            const existing = this.#rules.get(ruleResult.id);
            if (!existing) {
                const { uniques, duplicates, ...header } = ruleResult;
                this.#rules.set(ruleResult.id, {
                    header: structuredClone(header),
                    uniqueCount: uniques.length,
                    duplicates: structuredClone(duplicates)
                });
                continue;
            }
            existing.uniqueCount += ruleResult.uniques.length;
            for (const [key, count] of Object.entries(ruleResult.duplicates)) {
                existing.duplicates[key] = (existing.duplicates[key] || 0) + count;
            }
        }
    }
    values() {
        return this.#rules.values();
    }
}
exports.MergedRules = MergedRules;
//# sourceMappingURL=mergedRules.js.map